import * as React from 'react';

import { LogError } from '../common/ReactErrorLog';
import { useAdaptiveSettings } from '../../../common/hooks';
import { usePublishTermsLoadingTelemetry } from '../PublishTerms/hooks';
import { PublicationError } from '../Publication/components/PublicationError';
import { EPublishTermsStatus } from '../../types/reducers/publishTerms';
import { PublishTermsLoading } from '../Publication/components/PublishTermsLoading';
import { ServicePickerWidgetContent } from './components/ServicePickerWidgetContent';
import { ServicePickerWidgetStatus } from './components/ServicePickerWidgetStatus';
import { useScriptsLoadingErrorsLogger, useWebviewEventsHandlers } from './hooks';

const loadingStatusToComponent: Record<EPublishTermsStatus, React.ReactElement> = {
  [EPublishTermsStatus.pending]: <PublishTermsLoading />,
  [EPublishTermsStatus.initial]: <PublishTermsLoading />,
  [EPublishTermsStatus.fail]: <PublicationError />,
  [EPublishTermsStatus.success]: <ServicePickerWidgetContent />,
};

export const ServicePickerWidget = () => {
  useAdaptiveSettings();
  usePublishTermsLoadingTelemetry();
  useScriptsLoadingErrorsLogger();
  useWebviewEventsHandlers();

  return (
    <div data-testid="service-picker-widget">
      <LogError>
        <ServicePickerWidgetStatus statusToComponent={loadingStatusToComponent} />
      </LogError>
    </div>
  );
};
